var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapCustomMarker',{attrs:{"marker":{
    lat: _vm.group.lat,
    lng: _vm.group.lng
  },"delayRepaint":0,"offsetY":0},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click')}}},[_c('div',{staticClass:"marker"},[_vm._v(" "+_vm._s(_vm.group.count)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }